export const statusOptions = {
    pending: {
        value:'pending',
        number:1,
        displayName:'تم التقديم',
        class:'my-2 badge bg-opacity-10 bg-warning text-warning',
    },
    secretary_accepted: {
        value:'secretary_accepted',
        number:2,
        displayName:'السكرتارية',
        class:'my-2 badge bg-opacity-10 bg-success text-success',
    },
    nominated: {
        value:'nominated',
        number:2,
        displayName:'مرشحة',
        class:'my-2 badge bg-opacity-10 bg-success text-success',
    },
    secretary_rejected: {
        value:'secretary_rejected',
        number:2,
        displayName:'السكرتارية',
        class:'my-2 badge bg-opacity-10 bg-danger text-danger',
    },
    manager_approved: {
        value:'manager_approved',
        number:3,
        displayName:'الإدارة',
        class:'my-2 badge bg-opacity-10 bg-success text-success',
    },
    manager_rejected: {
        value:'manager_rejected',
        number:3,
        displayName:'الإدارة',
        class:'my-2 badge bg-opacity-10 bg-danger text-danger',
    },
    ready: {
        value:'ready',
        number:4,
        displayName:'يرجى الاستلام',
        class:'my-2 badge bg-opacity-10 bg-info text-info',
    },
    received: {
        value:'received',
        number:5,
        displayName:'تم التسليم',
        class:'my-2 badge bg-opacity-10 bg-success text-success',
    },
}